import loadable from '@loadable/component';
import LoadingComponentLoadable from '../../../components/Loading/Lazy';

const PoliLoadable = loadable(() => import(/* webpackChunkName: "poli-page" */ './index'), {
  fallback: <LoadingComponentLoadable />,
});

export default PoliLoadable;
